import { createContext } from 'react';
export const FileDropZoneContext = createContext({
    disabled: false,
    focused: false,
    type: 'file',
    allowMultiple: true,
});
//# sourceMappingURL=FileDropZoneContext.js.map